export const functionNames = [
    { value: "STRING-REPLACE", label: 'Replace', type: 'string' },
    { value: "STRING-TRIM", label: 'Trim', type: 'string' },
    { value: "STRING-ASSIGN", label: 'Assign', type: 'string' },
    { value: "STRING-LOWERCASE", label: 'Lowercase', type: 'string' },
    { value: "STRING-UPPERCASE", label: 'Uppercase', type: 'string' },
    { value: "STRING-SUBSTRING", label: 'Substring', type: 'string' },

    { value: "NUMBER-ASSIGN", label: 'Assign', type: 'number' },
    { value: "NUMBER-RANDOM", label: 'Random', type: 'number' },

    { value: "OBJECT-APPEND", label: 'Append', type: 'object' }
]

// fields: {name:{
// value:
// type:
// functions:[{
// name:
// fields:
// conditions:
//}]
//}}


// const functions = [{
//     id: 1,
//     label: 'Replace',
//     type: 'string',
//     parameters: [{ name: 'findString', type: 'string', required: true }, { name: 'replaceWith', type: 'string', required: true }, { name: 'isMatchCase', type: 'string', required: false, default: 'active' }],
//     action: {
//         name: 'REPLACE',
//         libraryName: 'STRING',
//         actionName: 'REPLACE',
//         fields: {
//             sourceString: { value: '-', defaultValue: true },
//             set: { value: '-', type: 'VARIABLEPICKER' } // , defaultValue: true 
//         },
//         isDebugging: false,
//     }
// }, {
//     id: 2,
//     label: 'Trim',
//     type: 'string',
//     parameters: [{ name: 'trimBegin', required: false, default: false }, { name: 'trimEnd', required: false, default: false }],
//     action: {
//         name: 'TRIM',
//         libraryName: 'STRING',
//         actionName: 'TRIM',
//         fields: {
//             sourceString: { value: '-', defaultValue: true },
//             set: { value: '-', type: 'VARIABLEPICKER' } // , defaultValue: true
//         },
//         isDebugging: false
//     }
// }, {
//     id: 3,
//     label: 'Append',
//     type: 'object',
//     parameters: [{ name: 'item', required: true }],
//     action: {
//         name: 'APPEND',
//         libraryName: 'OBJECT',
//         actionName: 'APPEND',
//         fields: {
//             set: { value: '-', defaultValue: true } // , defaultValue: true
//         },
//         isDebugging: false,
//     }
// }]

// module.exports = functions;
export const functionList = {
    "STRING-REPLACE": {
        parameters: [{ name: 'findString', required: true }, { name: 'replaceWith', required: true }, { name: 'isMatchCase', required: false, default: 'active' }],
        name: "Replace"
    },
    "STRING-TRIM": {
        parameters: [{ name: 'trimBegin', required: false, default: false }, { name: 'trimEnd', required: false, default: false }],
        name: "Trim"
    },
    "STRING-ASSIGN": {
        parameters: [],
        name: "Assign"
    },
    "STRING-LOWERCASE": {
        parameters: [],
        name: "Lowecase"
    },
    "STRING-UPPERCASE": {
        parameters: [],
        name: "Uppercase"
    },
    "STRING-SUBSTRING": {
        parameters: [{ name: 'startFrom', required: true, default: '' }, { name: 'length', required: true, default: '' }],
        name: "Substring"
    },

    "NUMBER-ASSIGN": {
        parameters: [{ name: 'assignValue', required: true, default: '' }],
        name: "Assign"
    },
    "NUMBER-RANDOM": {
        parameters: [{ name: 'beginRange', required: true, default: 0 }, { name: 'endRange', required: true, default: 0 }],
        name: "Random"
    },

    "OBJECT-APPEND": {
        parameters: [{ name: 'item', required: true }],
        name: "Append"
    }
}

export const actionList = {
    "STRING-REPLACE": {
        libraryName: 'STRING',
        actionName: 'REPLACE',
        fields: {
            sourceString: { value: '-', defaultValue: true },
        },
        isDebugging: false,
        name: 'REPLACE'
    },
    "STRING-TRIM": {
        libraryName: 'STRING',
        actionName: 'TRIM',
        fields: {
            sourceString: { value: '-', defaultValue: true },
        },
        isDebugging: false,
        name: 'TRIM'
    },
    "STRING-ASSIGN": {
        libraryName: 'STRING',
        actionName: 'ASSIGN',
        fields: {
            assignSource: { value: '-', defaultValue: true },
        },
        isDebugging: false,
        name: 'ASSIGN'
    },
    "STRING-LOWERCASE": {
        libraryName: 'STRING',
        actionName: 'LOWERCASE',
        fields: {
            sourceString: { value: '-', defaultValue: true },
        },
        isDebugging: false,
        name: 'LOWERCASE'
    },
    "STRING-UPPERCASE": {
        libraryName: 'STRING',
        actionName: 'UPPERCASE',
        fields: {
            sourceString: { value: '-', defaultValue: true },
        },
        isDebugging: false,
        name: 'UPPERCASE'
    },
    "STRING-SUBSTRING": {
        libraryName: 'STRING',
        actionName: 'SUBSTRING',
        fields: {
            sourceString: { value: '-', defaultValue: true },
        },
        isDebugging: false,
        name: 'SUBSTRING'
    },

    "NUMBER-ASSIGN": {
        libraryName: 'NUMBER',
        actionName: 'ASSIGN',
        fields: {
            sourceString: { value: '-', defaultValue: true },
        },
        isDebugging: false,
        name: 'ASSIGN'
    },
    "NUMBER-RANDOM": {
        libraryName: 'NUMBER',
        actionName: 'RANDOM',
        fields: {},
        isDebugging: false,
        name: 'RANDOM'
    },

    "OBJECT-APPEND": {
        libraryName: 'OBJECT',
        actionName: 'APPEND',
        fields: {
            set: { value: '-', defaultValue: true } // , defaultValue: true
        },
        isDebugging: false,
        name: 'APPEND'
    }
}